import Vue from 'vue';
import VueRouter from 'vue-router';
import {store} from './store'
import axios from "axios";
import LoginPage from "@/components/LoginPage.vue";
import PasswordPage from "@/components/PasswordPage.vue";
import ErrorPage from "@/components/ErrorPage.vue";
import IdentifyPage from "@/components/IdentifyPage.vue";
import MainPage from "@/components/MainPage.vue";
import HistoryPage from "@/components/HistoryPage.vue";
import InputNumberPage from "@/components/InputNumberPage.vue";
import InputSumPage from "@/components/InputSumPage.vue";
import InputConfirmPage from "@/components/InputConfirmPage.vue";
import PayEndPage from "@/components/PayEndPage.vue";
import OfertPage from "@/components/OfertPage.vue";
import StartPage from "@/components/StartPage.vue";

Vue.use(VueRouter);

const loadPointInfo = (to, from, next) => {
  const query = new URLSearchParams(window.location.search);
  const point = query.get('point') || '';
  let password = query.get('password') || '';
  if (point.length > 0 && password.length > 0) {
    sendAuth(point, password).then((res) => {
      if (res && res.status == 1) {
        localStorage.setItem('point', point)
        localStorage.setItem('token', res.token)
        window.location.href = window.location.protocol + '//' + window.location.host + '/'
      } else {
        next('/error');
      }
    })
  } else {
    const point_ = localStorage.getItem('point') || '';
    const token_ = localStorage.getItem('token') || '';
    if (point_.length > 0 && token_.length > 0) {
      next();
    } else {
      next('/error');
    }
  }
}

const sendAuth = async (point, password) => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  const { data } = await axios.post('/wallet/auth/auth-point', {point: point, password: password}, config)
  return data;
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
  } else {
    store.dispatch('AUTH_LOGOUT')
  }
};

const routes = [
  {
    path : '/',
    component : StartPage,
    beforeEnter: loadPointInfo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/login',
    component : LoginPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/password',
    component : PasswordPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/start',
    component : StartPage,
    beforeEnter: loadPointInfo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/main',
    component : MainPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/history',
    component : HistoryPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/identify',
    component : IdentifyPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/input-number',
    component : InputNumberPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/input-sum',
    component : InputSumPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/input-confirm',
    component : InputConfirmPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/pay-end',
    component : PayEndPage,
    beforeEnter: ifAuthenticated,
    meta: {
      requiresAuth: true
    }
  },
  {
    path : '/ofert',
    component : OfertPage,
  },
  {
    path : '/error',
    component : ErrorPage,
    meta: {
      requiresAuth: true
    }
  },
];

export default new VueRouter({
  mode: 'hash',
  routes: routes
});

